<template>
    <div class="container">
        <div>
            <div class="row page-content">
                <div class="col-12">
                    <h1 class="page-heading text-dark">
                        Booster Gallery
                    </h1>
                </div>

                <div class="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-12 mb-4" v-if="sets" v-for="set in sets">
                    <h5>{{ set.set_name }} <small class="muted">/ {{ set.set_id }}</small></h5>
                    <div class="booster-slider">
                        <a v-for="packshot in set.packshots" :data-lightbox="set.id" :href="packshot">
                            <img :src="packshot" alt="packshot-image" class="packshot-image">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import axios from "axios";

export default {
    name: "BoosterGallery",
    data() {
        return {
            sets: null
        }
    },
    mounted() {
        this.$store.commit('updateUserData');
        this.fetchPackshots();
    },
    methods: {
        fetchPackshots() {
            axios.get('https://dipocaco.me/api/packshots').then(response => {
                this.sets = response.data;
            })
        }
    },
}
</script>

<style lang="scss" scoped>
.booster-slider {
    max-width: 100%;
    overflow-x: auto;
    white-space: nowrap;

    .packshot-image {
        width: calc(25% - 1em);
        height: auto;
        margin-right: 1em;
    }
}
</style>
